import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import InvoiceEditClient from "@/components/invoices/invoice-edit-client";

export const Route = createFileRoute("/_authenticated/invoices/$id/edit")({
  component: InvoiceEditPage,
});

function InvoiceEditPage() {
  const { id } = Route.useParams();
  const search = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "invoices", actions: ["read", "update"] }]}
    >
      <InvoiceEditClient id={id} searchParams={search} />
    </RouteGuardPermissions>
  );
}
